import createModule from "../createModule"
import { getToken } from "./selectors"
import view from "./view"
import { Creators } from "./model"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  mapStateToProps: (state, props) => ({
    token: getToken(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
